<!-- 教室设置 -->
<template>
  <div class="app-container">
    <!--查询条件区域-->
    <!-- <el-collapse   v-model="activeName" accordion>
      <el-collapse-item :name="1">
        <template slot="title">
          <div class="title-container" shadow="never">
            <div class="title-con">
              <i class="el-icon-search"></i>
              <span style="margin-left: 5px;">筛选搜索</span>
            </div>
          </div>
        </template>

      <el-card class="operate-container" shadow="never" style="margin-top: 0px;">
          <div class="filter-container" style="margin-top: 10px ;display:none;">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="店铺:">
                <el-input v-model="queryParam.shopFrontId" placeholder="店铺ID"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="filter-container" style="margin-top: 10px">
            <el-form :inline="true" :model="queryParam" label-width="140px">
              <el-form-item label="教室名称:">
                <el-input v-model="queryParam.classroomName" placeholder="教室名称"></el-input>
              </el-form-item>
            </el-form>
          </div>
          <div class="button-container" style="margin-top: 0px">
            <el-button type="warning" size="medium" class="operator-btn2" icon="el-icon-refresh" @click="handleResetSearch()">重 置</el-button>
            <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-search" @click="onBtnSearch()">查 询</el-button>
          </div>
        </el-card>
      </el-collapse-item>

    </el-collapse> --> 


    <!--    查询结果区域-->
    <div class="title-container" shadow="never" style="margin-top: 20px;">
      <div class="title-con">
        <i class="el-icon-tickets"></i>
        <span style="margin-left: 5px;">门店动态列表</span>
      </div>
      <div>
        <el-button type="primary" size="medium" class="operator-btn" icon="el-icon-circle-plus-outline" @click="handleCreateOne()">新增</el-button>
      </div>
    </div>
    <div class="table-container" style="margin-top: 0px;">
      <el-table
        :data="tableData"
        :header-cell-style="{'text-align':'center'}"
        :cell-style="{'text-align':'center'}"
        v-loading="listLoading"
        ref="seleteTable"
        max-height="650"
        border>
        <el-table-column prop="title" label="新闻标题" ></el-table-column>
        <el-table-column prop="newPic" label="新闻图片" >
          <template slot-scope="scope">
            <el-image style ="width:50px; height: 50px"
            :src="scope.row.newPic"
            :preview-src-list="srcList"
            @click="deleteSrc(scope.row.newPic)">
            </el-image>
          </template>
        </el-table-column>
        <el-table-column prop="shortContext" label="新闻描述" ></el-table-column>
        <el-table-column prop="context" label="新闻内容" :show-overflow-tooltip='true'></el-table-column>
        <el-table-column prop="createTime" label="创建时间" ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-button @click="handleDeleteOne(scope.row)" type="danger" plain size="small">删除</el-button>
            <!-- <el-button @click="handleUpdateOneDlg(scope.row)" type="danger" plain size="small">修改</el-button> -->
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div class="pagination-container">
      <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              layout="total, sizes, prev, pager, next, jumper"
              :current-page="queryParam.pageNum"
              :page-size="queryParam.pageSize"
              :page-sizes="queryParam.pageSizes"
              :total="queryParam.totalPage">
      </el-pagination>
    </div>
    <el-dialog
            title="添加动态"
            :visible.sync="visibleDlgAdd"
            width="50%"
            center>
      <div>
        <el-form  ref="addForm"  :model="addParam" :rules="rules" label-width="150px">
          <el-form-item  label="动态标题" prop="title" >
            <el-input v-model="addParam.title" placeholder="请输入内容"></el-input>
          </el-form-item>
          <el-form-item label="图片" prop="newPic">
            <el-upload
              :action="uploadAction"
              :headers="importHeaders"
              :on-success="handleUploadSuccess"
              :file-list="fileList"
              :limit=1
              list-type="picture">
              <el-button size="small" type="primary">点击上传</el-button>
              <div slot="tip" class="el-upload__tip">只能上传jpg/png文件,图片文件不超过50kb</div>
            </el-upload>
          </el-form-item>
          <el-form-item  label="描述" prop="shortContext" >
            <el-input v-model="addParam.shortContext" type="textarea" :rows="5" placeholder="请输入描述"></el-input>
          </el-form-item>
          <el-form-item  label="内容" prop="context" >
            <el-input v-model="addParam.context" type="textarea" :rows="20" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="visibleDlgAdd = false">取消</el-button>
        <el-button type="primary" @click="handleAddOne">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<style scoped>
  /deep/ .el-table th.el-table__cell>.cell{
    width: 90%;
    height: auto;
    background: #ecf3fd;
    border-radius: 8px;
  }
  /deep/ .el-table__header-wrapper .cell{
    line-height: 45px;
    color: #0d6fb8;
  }
  /deep/ .el-dialog--center{
    border: 2px solid #d0d0d0;
    border-radius: 10px;
  }
  /deep/ .el-dialog__header{
    border-radius: 10px;
    background: #f0f7ff;
  }
</style>

<script>
  import globaldata from "../../../utils/globaldata";
  import commonUtils from "../../../utils/commonUtils";
  import {newsList,newsAdd,newsInActiveById} from "../../../api/storeFrontNews";
  import {getStaticData} from "@/api/staticData";
  import messageUtils from "../../../utils/messageUtils";
  import { getToken } from '@/utils/auth'
  export default {
    components:{},
    data() {
      return {
        fileList:[],
        srcList:[],
        videoFileList:[],
        visitPicList:[],
        refreVisitPic:"",
        uploadAction:'',
        importHeaders:'',
        listLoading: true,
        storeFrontId:globaldata.getAdminStore().storeFrontId,
        //查询参数
        queryParam: {
          //分页查询
          pageNum :1 ,//当前第几页
          pageSize : 10,
        },
        totalPage :1, //总共页数
        pageSizes:[20,50,100],
        //查询区域默认展开
        activeName:1,
        createParam :{
        },
        //删除
        deleteParam :{
        },
        addParam:{
          title:'',
          newPic :'',
          context:'',
          desc:'',
        },
        //弹窗
        visibleDlgAdd: false,
        //表单结果
        tableData: [
        ],
        allWorker:[],
        options: [{
          value: 'image',
          label: '图片'
        }, {
          value: 'video',
          label: '视频'
        }],
        rules:{
          title:[{required:true,message:"标题不能为空",trigger:"blur"}],
          newPic:[{required:true,message:"请上传图片",trigger:"blur"}],
          context:[{required:true,message:"内容不能为空",trigger:"blur"}],
          shortContext:[{required:true,message:"描述不能为空",trigger:"blur"}],
        },
      }


    },
    created(){
      this.fitchList()
      let mytoken = getToken();
      this.importHeaders  = {"Authorization": mytoken}
      getStaticData("").then(response =>
        {
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.uploadAction = data.uploadChildPhotoImageUrl+'/'+this.storeFrontId;
        })
    },
    mounted() {

    },
    methods: {
      onVisitPics(pics){
        this.visitPicList = pics;
        this.visibleVisitPic = true;
        this.refreVisitPic = new Date().getTime();
      },
      deleteSrc(val) {
        this.srcList = []
        this.srcList.push(val)
      },
      //点击查询按钮
      onBtnSearch() {
        this.fitchList();
      },
      handleCurrentChange(val) {
        this.queryParam.pageNum = val;
        this.fitchList();
      },
      handleSizeChange(val) {
        this.queryParam.pageSize = val;
        this.fitchList();
      },
      refreshData(list){
        this.tableData = list;
      },
      //添加一个
      handleCreateOne(){
        this.visibleDlgAdd = true;
      },
      onBtnOK(){
        this.visibleDlg = false;
        this.fitchList();
      },
      //新增保存
      onClassroom(data){
        data.shopFrontId =globaldata.getAdminStore().storeFrontId;
        addClassroom(data).then(response =>
        {
          messageUtils.successMsg(this,response.message)
          this.visibleDlg = false;
          this.fitchList();
        })
      },
      onBtnCancel(){
        this.visibleDlg = false;
      },
      handleUploadSuccess(res, file){
        if(res.code != 20000){
          messageUtils.errorMsg(this,res.message)
          return
        }
        messageUtils.successMsg(this,"上传成功");
        this.addParam.newPic = res.data
      },
      handleVideoUploadSuccess(res, file){
        if(res.code != 20000){
          messageUtils.errorMsg(this,res.message)
          return
        }
        messageUtils.successMsg(this,"上传成功");
        this.addParam.newPic = res.data
      },
      //刪除
      handleDeleteOne(row){
        this.$confirm('是否确认删除?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',

        }).then(() => {
          let param = {
            id:row.id,
          }
          newsInActiveById(param).then(response => {
            let code = response.code;
            if (code == 20000){
              messageUtils.successMsg(this,response.message);
              this.fitchList();
            }else {
              messageUtils.errorMsg(this,response.message);
            }
          })
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });
        });
      },
      fitchList(){
        this.listLoading = true;
        this.queryParam.storeFrontId = this.storeFrontId
        newsList(this.queryParam).then(response => {
          this.listLoading = false;
          let data = response.data;
          if (commonUtils.isObjectNull(data)){
            return;
          }
          this.queryParam.totalPage = data.total;

          this.refreshData(data.records);
        })
      },
     
      handleAddOne() {
        this.$refs['addForm'].validate(valid=>{
          if(valid){
            let param = {
              storeFrontId:this.storeFrontId,
              title:this.addParam.title,
              context:this.addParam.context,
              newPic:this.addParam.newPic,
            }
            newsAdd(param).then(response =>
            {
              let code = response.code;
              if (code == 20000){
                messageUtils.successMsg(this,response.message);
                this.visibleDlgAdd= false;
                this.fitchList();
              }else {
                messageUtils.errorMsg(this,response.message);
              }
            })
            this.addParam={}
            this.fileList=[]
            this.videoFileList=[]
          }
        })
      },
    }
  }



</script>






// WEBPACK FOOTER //
// src/views/my-store/news/index.vue